import { useState } from "react";
import Cleave from "cleave.js/react";
//-----------------------------------------------------
import Modal from "src/components/common/modal";
import AutoComplete from "src/components/common/autoComplete";
import { states, cityStates } from "src/components/common/cityState";
import { useMyStore } from "src/components/main/mainStore";
import { 
    Select, 
    projectCategoryColorCode, 
} from "src/components/common/functions";
export const myOptions = {
    region: ["Hayward", "Fresno", "Sacramento", "LA", "Arizona"],
    department: {
        "In-House Labor": ["Potholing", "Locating", "Mapping&Surveying", "Scanning&Coring", "CCTV", "QA/QC", "Traffic Control", "Hydro Vac Excavation", "Straight Vacuum Services", "Sawcutting"],
        "Office": ["Executive", "Project Management", "Administration", "Accounting", "Marketing", "IT", "Safety"],
        "Location": ["LA", "Arizona"], 
        "Outside Service": ["Outside Service"],
        "3rd Party": ["3rd Party"]
    },
    phaseLevel: {
        "185": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "270": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"], 
        "304": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "1245":["Locator", "QEW", "Standby", "Scanning/Coring"],
        "Local 3":["Operating Engineer"],
        "Local 12":["Operating Engineer"],
        "Local 294":["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "SC Local 300": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "SC Local 652": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "SC Local 1184": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "Local 783":["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "Non-Union":["Non-Union"]
    },
    safetyCodeOptions: [
        "5029 concrete or asphalt cutting and drilling",
        "6218 Excavation backfilling apprentice",
        "6220 Excavation backfilling Journey",
        "7721 Traffic Control",
        "8601 Engineering"
    ]
}
export const myAccessOptions = {
    projects: ["no", "fill", "yes", "full", "readOnly", "admin"],
    workLogs: ["no", "yes"],
    purchases: ["no", "yes", "paid", "approver"],
    perDiem: ["no", "yes", "paid", "all"],
    newspaper: ["no", "yes"],
    fleets: ["no", "yes"],
    reports: ["no", "yes"],
    forms: ["normal", "approver"],
    personel: ["no", "yes", "read", "outside", "dispatch"],
    calendar: ["no", "yes"],
    office: ["no", "yes"],
    allOffice: ["no", "yes","runners", "all"],
    dayOff: ["no","normal", "all"],
    outsideStatus: ["no", "yes"],
    outside: ["no", "locator", "standby", "qew", "runner"],
    paymentMethods: ["no", "yes"],
    payroll: ["no", "edit"]
}
//-----------------------------------------------------
export default function UserForm({
    email, shouldDisable, firstName, middleName, lastName, phoneNumber, 
    extension, role, ssn, projects, workLogs, purchases, 
    fleets, reports, forms, personel, background,
    postUrl, keyword, handleSubmit, closeIt, region, office, btlNumber, calendar,
    workPhone, unionName, phaseLevel, hireDate, quitDate, birthDay, driverLicense, lanId, outside, 
    outsideTimeCards, googleAccount, department,
    allOffice, outsideStatus, residenceState, residence, street, zipCode, 
    googleCalendar, dayOff, perDiem, newspaper, address, coords, safetyCode, paymentMethods, payroll,
    employee_id, classification
}){
    const curUser = useMyStore(state => state.user);
    const calendarCategory = Object.keys(projectCategoryColorCode);
    //-----------------------------------------------------
    const outsideReactSelectOptions = [ 
        { value: "standby", label: "standby" },
        { value: "locator", label: "locator" },
        { value: "qew", label: "qew" }
    ];
    //-----------------------------------------------------
    const [curUnionName, setUnionName] = useState(unionName || "");
    const [curOutside, setOutside] = useState(outside || "");
    const [curOutsideTimeCards, setOutsideTimeCards] = useState(outsideTimeCards?outsideTimeCards.split(", ").map(ee => ({value: ee, label: ee})):[]);
    const [curDepartment, setDepartment] = useState(department || "");
    const [curResidenceState, setResidenceState] = useState(residenceState || "CA");
    const [curQuitDate, setQuitDate] = useState(quitDate ?? "");
    const [curGoogleCalendar, setGoogleCalendar] = useState(googleCalendar?JSON.parse(googleCalendar):
    Object.fromEntries(Object.keys(projectCategoryColorCode).map(key => ([key, ""]))));
    //-----------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"1400px"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div className = "row" style = {{display: "flex", alignItems: "stretch"}}>
                <div style = {{flexGrow: 1, padding:"10px 10px 10px 20px"}}>
                    <input
                        readOnly className = "nodisplay"
                        name = "url" value = {postUrl}
                    />
                    <input
                        readOnly className = "nodisplay"
                        name = "keyword" value = {keyword}
                    />
                    <input
                        readOnly className = "nodisplay"
                        name = "curOutside" value = {outside || ""}
                    />
                    <input
                        readOnly className = "nodisplay"
                        name = "curOffice" value = {office || ""}
                    />
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2 required-field">Email:</span>
                        <input
                            required
                            type = "email"
                            className = "form-control"
                            style = {{
                                flexGrow: 1, 
                                textTransform: "lowercase"
                            }}
                            name = "userEmail"
                            readOnly = {shouldDisable}
                            defaultValue = {email}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Name:</span>
                        <input
                            required placeholder = "First Name"
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            name = "firstName"
                            defaultValue = {firstName || ""}
                        />
                        <input
                            placeholder = "Middle Name"
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            name = "middleName"
                            defaultValue = {middleName || ""}
                        />
                        <input
                            required
                            placeholder = "Last Name"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "lastName"
                            defaultValue = {lastName || ""}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Phone:</span>
                        <Cleave
                             required
                            placeholder = "Mobile Phone"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                            className = "form-control mr-3" style = {{flexGrow: 1}} name = "phoneNumber" value = {phoneNumber || ""}
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                        <Cleave
                            placeholder = "Work Phone"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                            className = "form-control mr-3" style = {{flexGrow: 1}} name = "workPhone" value = {workPhone || ""}
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                        <input
                            placeholder = "Office Extension"
                            type = "number"
                            step = "any"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "extension"
                            defaultValue = {extension || ""}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2" style = {{verticalAlign:"middle", lineHeight: 1.9}}>Address:</span>
                        <AutoComplete
                            className = "m-2"
                            location = {address}
                            coords = {coords?coords.split(",").map(Number):undefined} 
                            locationName = "address" 
                            coordsName = "coords"
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Region:</span>
                        <select
                            required
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            name = "region"
                            defaultValue = {region || ""}
                        >
                            {curUser.personel !== "outside"?
                            <>
                            <option value = "">Select</option>
                            {myOptions.region.map((o, oi) => <option key = {oi}>{o}</option>)}
                            </>
                            :<option>Sacramento</option>}
                        </select>
                        <span className = "font-weight-bold mr-3 py-2">Department:</span>
                        <select
                            required
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            name = "department"
                            defaultValue = {department || ""}
                            onChange = {e => {setDepartment(e.currentTarget.value)}}
                        >
                            {curUser.personel !== "outside"?<>
                            <option value = "">Select</option>
                            {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                            </>
                            :
                            <optgroup label = "Outside Service">
                                <option>Outside Service</option>
                            </optgroup>}
                        </select>
                        <span className = "font-weight-bold mr-3 py-2">Role:</span>
                        {curDepartment !== "Outside Service" && curUser.personel !== "outside"?
                        <input
                            required
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "role"
                            defaultValue = {role || ""}
                        />:
                        <select
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "role" defaultValue = {role || ""}
                        >
                            <option value = "">Select</option>
                            <option>M&L</option>
                            <option>QEW</option>
                            <option>Gas Standby</option>
                        </select>
                        }
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Union Name:</span>
                        <select
                            required
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            name = "unionName"
                            defaultValue = {curUnionName}
                            onChange = {e => {
                                setUnionName(e.currentTarget.value);
                            }}
                        >
                            {curUser.personel !== "outside"?
                            <>
                            <option value = "">Select</option>
                            {Object.keys(myOptions.phaseLevel).map((o, oi) => <option key = {oi}>{o}</option>)}
                            </>
                            
                            :<>
                                <option value = "">Select</option>
                                <option>1245</option>
                                <option>Non-Union</option>
                            </>}
                        </select>
                        {curUnionName !== "Runner"?<>
                        <span className = "font-weight-bold mr-3 py-2">Phase and Level:</span>
                        <select
                            required
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "phaseLevel"
                            defaultValue = {phaseLevel || ""}
                        >
                            <option value = "">Select</option>
                            {curUnionName || curUser.personel === "outside"?
                            myOptions.phaseLevel[
                                curUnionName || (curUser.personel === "outside"?"1245":null)].map((option, i) => <option key = {i}>{option}</option>):null}
                        </select>
                        </>:null}
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2 required-field">Safety Code:</span>
                        <select
                            required
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "safetyCode"
                            defaultValue = {safetyCode || ""}
                        >
                            <option value = "">Select</option>
                            {myOptions.safetyCodeOptions.map((option, i) => <option key = {i} value = {i + 1}>{option}</option>)}
                        </select>
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">SSN:</span>
                        <Cleave
                            pattern = "[0-9]{3}-[0-9]{2}-[0-9]{4}|$^"
                            className = "form-control mr-3" style = {{flexGrow: 1}} name = "ssn" value = {ssn || ""}
                            options = {{
                                blocks:[3, 2, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                        <span className = "font-weight-bold mr-3 py-2">Birthday:</span>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            name = "birthDay"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            defaultValue = {birthDay ?? ""}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex", alignItems: "center"}}>
                        <span className = "font-weight-bold py-2">Driver License:</span>
                        <span className = "font-weight-bold ml-1 py-2 h3 mb-0 text-info" data-toggle = "tooltip" title = {`only accept Capitalized Letters and Numbers`}>ⓘ</span>
                        <input
                            name = "driverLicense"
                            pattern = "[A-Z0-9]*"
                            className = "ml-3 form-control"
                            style = {{flexGrow: 1}}
                            defaultValue = {driverLicense ?? ""}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">EE ID:</span>
                        <input
                            name = "employee_id"
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            defaultValue = {employee_id ?? ""}
                        />
                        <span className = "font-weight-bold mr-3 py-2">Classification:</span>
                        <input
                            name = "classification"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            defaultValue = {classification ?? ""}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Hire Date:</span>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            required
                            name = "hireDate"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            defaultValue = {hireDate ?? ""}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Leave Date:</span>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            name = "quitDate"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            value = {curQuitDate}
                            onChange = {e => setQuitDate(e.currentTarget.value)}
                        />
                        <span className = "btn btn-primary ml-3" onClick = {() => {setQuitDate("")}}>Clear Leave Date</span>
                    </div>
                    {(curOutside !== "") && (curOutside !== "no")?
                    <>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Residence:</span>
                        <input
                            type = "text"
                            className = "form-control mr-3"
                            placeholder = "Street"
                            name = "street"
                            defaultValue = {street}
                        />
                        <select
                            className = "form-control mr-3"
                            style = {{
                                flexGrow: 1
                            }}
                            name = "residence"
                            defaultValue = {residence || ""}
                        >
                            <option value = "">Select City</option>
                            {curResidenceState && cityStates[curResidenceState].map((option, i) => <option key = {i}>{option}</option>)}
                        </select>
                        <select
                            className = "form-control mr-3"
                            style = {{
                                flexGrow: 1
                            }}
                            name = "residenceState"
                            value = {curResidenceState}
                            onChange = {e => {
                                setResidenceState(e.currentTarget.value);
                            }}
                        >
                            <option value = "">Select State</option>
                            {states.map((option, i) => <option key = {i}>{option}</option>)}
                        </select>
                        <input
                            type = "text"
                            className = "form-control"
                            placeholder = "Zip Code"
                            name = "zipCode"
                            defaultValue = {zipCode}
                        />
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">BTL No.:</span>
                        <input
                            pattern = "[0-9]{2}-[0-9]{1}-[0-9]{4}|[0-9]{2}-[0-9]{4}|$^"
                            className = "form-control mr-3"
                            style = {{flexGrow: 1}}
                            name = "btlNumber"
                            defaultValue = {btlNumber || ""}
                        />
                        <span className = "font-weight-bold mr-3 py-2">Lan Id:</span>
                        <input
                            type = "text" 
                            name = "lanId"
                            className = "form-control" 
                            style = {{
                                flexGrow: 1,
                                textTransform: "uppercase"
                            }}
                            maxLength = {4}
                            minLength = {4}
                            defaultValue = {lanId || ""}
                        />
                    </div>
                    </>
                    :null}
                    <div className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Google Account:</span>
                        <select
                            required = {googleAccount === undefined}
                            name = "googleAccount"
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            defaultValue = {googleAccount || ""}>
                            {curUser.personel !== "outside"?
                            <>
                            <option value = "">Select</option>
                            <option>Yes</option>
                            <option>No</option>
                            </>
                            :<option>No</option>}
                        </select>
                    </div>
                    {calendarCategory.map((key, k) =>
                    <div key = {k} className = "my-2" style = {{display: "flex"}}>
                        <span className = "font-weight-bold mr-3 py-2">Google Calendar - {key}:</span>
                        <select
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            value = {curGoogleCalendar[key] ?? ""}
                            onChange = {e => {
                                setGoogleCalendar({...curGoogleCalendar, [key]:e.currentTarget.value});
                            }}
                        >
                            {curUser.personel !== "outside"?
                            <>
                            <option>Yes</option>
                            <option value = "">No</option>
                            </>
                            :<option value = "">No</option>}
                        </select>
                        
                    </div>
                    )}
                    <input
                        name = "prevGoogleCalendar"
                        value = {googleCalendar?googleCalendar:JSON.stringify(Object.fromEntries(Object.keys(projectCategoryColorCode).map(key => ([key, ""]))))}
                        readOnly
                        className = "nodisplay"
                    /> 
                    <input
                        name = "googleCalendar"
                        value = {JSON.stringify(curGoogleCalendar)}
                        readOnly
                        className = "nodisplay"
                    /> 
                    <div className = "my-2" style = {{display:"flex", alignItems: "center"}}>
                        <div className = "font-weight-bold mr-3">Background:</div>
                        <textarea className = "form-control" name = "background" style = {{width: "100%", height: "100%"}} defaultValue = {background}/>
                    </div>
                </div>
                <div style = {{flexGrow: 1, padding:"10px"}}>
                    <div className = "my-2 text-center">
                        <div className = "font-weight-bold mr-3 py-2" style = {{fontSize: "150%"}}>Access Control</div>
                    </div>
                    <div className = "rounded border p-4" style = {{display: "flex"}}>
                        <div className = "mr-5" style = {{flexGrow: 1}}>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Projects:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "projects"
                                    defaultValue = {projects || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.projects.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Work Logs:</span>
                                <select
                                    required className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "workLogs"
                                    defaultValue = {workLogs || ""}>
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.workLogs.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Purchase:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "purchases"
                                    defaultValue = {purchases || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.purchases.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Per Diem:</span>
                                <select
                                    required className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "perDiem"
                                    defaultValue = {perDiem || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.perDiem.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Newspaper:</span>
                                <select
                                    required className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "newspaper"
                                    defaultValue = {newspaper || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.newspaper.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Fleets:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "fleets"
                                    defaultValue = {fleets || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.fleets.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Reports:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "reports"
                                    defaultValue = {reports || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.reports.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Forms:</span>
                                <select
                                    required className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "forms"
                                    defaultValue = {forms || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.forms.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                        </div>
                        <div style = {{flexGrow: 1}}>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Personnel:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "personel"
                                    defaultValue = {personel || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.personel.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Calendar:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "calendar"
                                    defaultValue = {calendar || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.calendar.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            {curUser.personel !== "outside"?
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Time Off:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "dayOff"
                                    defaultValue = {dayOff || ""}
                                >
                                    <option value = "">Select</option>
                                    {myAccessOptions.dayOff.map((o, oi) => <option key = {oi}>{o}</option>)}
                                </select>
                            </div>
                            :null}
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Office:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "office"
                                    defaultValue = {office || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.office.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Office Status:</span>
                                <select
                                    required
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    name = "allOffice"
                                    defaultValue = {allOffice || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.allOffice.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Outside Service:</span>
                                    <select
                                        style = {{flexGrow: 1}}
                                        required
                                        className = "form-control"
                                        name = "outside"
                                        onChange = {e => {
                                            setOutside(e.currentTarget.value);
                                            if(e.currentTarget.value !== "no"){
                                                setOutsideTimeCards(outsideReactSelectOptions.filter(ee => ee.value === e.currentTarget.value))
                                            }else{
                                                setOutsideTimeCards([]);
                                            }
                                        }}
                                        value = {curOutside}
                                    >
                                        <option value = "">Select</option>
                                        {curUser.personel !== "outside"?
                                        <>
                                        {myAccessOptions.outside.map((o, oi) => <option key = {oi}>{o}</option>)}
                                        </>
                                        :<>
                                        <option>runner</option>
                                        <option>locator</option>
                                        <option>standby</option>
                                        <option>qew</option>
                                        </>}
                                    </select>
                            </div>
                            {curOutside !== "no"?<div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Outside Service Timecards:</span>
                                <div style = {{flexGrow: 1}}>
                                    <Select
                                        onChange = {e => {
                                            if(curOutside === "runner"){
                                                setOutsideTimeCards([]);return;
                                            }
                                            setOutsideTimeCards(e);
                                            if(!e?.filter(ee => ee.value === curOutside).length){
                                                setOutsideTimeCards([{label: curOutside, value: curOutside}, ...e]);
                                            }
                                        }}
                                        options = {outsideReactSelectOptions}
                                        value = {curOutsideTimeCards}
                                        isMulti
                                    />
                                    <input
                                        readOnly className = "nodisplay"
                                        name = "outsideTimeCards" value = {curOutsideTimeCards?.map(ee => ee.value).join(", ")}
                                    />
                                    <input
                                        readOnly className = "nodisplay"
                                        name = "prevOutsideTimeCards" value = {outsideTimeCards}
                                    />
                                </div>
                            </div>:null}
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Outside Service Status:</span>
                                <select
                                    required
                                    name = "outsideStatus"
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    type = "text"
                                    defaultValue = {outsideStatus || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.outsideStatus.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Payment Methods:</span>
                                <select
                                    required
                                    name = "paymentMethods"
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    defaultValue = {paymentMethods || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.paymentMethods.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                            <div className = "my-2" style = {{display: "flex"}}>
                                <span className = "font-weight-bold mr-3 py-2 required-field">Payroll:</span>
                                <select
                                    required
                                    name = "payroll"
                                    className = "form-control"
                                    style = {{flexGrow: 1}}
                                    defaultValue = {payroll || ""}
                                >
                                    {curUser.personel !== "outside"?
                                    <>
                                    <option value = "">Select</option>
                                    {myAccessOptions.payroll.map((o, oi) => <option key = {oi}>{o}</option>)}
                                    </>
                                    :<option>no</option>}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}